import React from 'react';
import { useWindowHook } from 'pu-utils/windowHook';

import PriceMatrix from './PriceMatrix';
import MobilePrice from './mobile/MobilePrice';
import QuoteRules from '../quote-rules/QuoteRules';

const PriceUs = (props) => {
  const { windowWidth } = useWindowHook();

  return (
    <div className="price-matrix">
      <div className="d-flex justify-content-between my-2">
        <h2 className="text-uppercase fw-bold">
          USA Pcb Assembly
        </h2>
      </div>
      {
        windowWidth >= 768
          ? <PriceMatrix {...props} />
          : <MobilePrice {...props} />
      }
      <QuoteRules />
    </div>
  );
}

export default PriceUs;
